export default __webpack_public_path__ + "media/images/images_v2/gradient1_prod-63151b11820f86d666eedb753dd7feb0.png";